module.exports = __webpack_public_path__ + "resource/img/information.50a2cef6.svg";